import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CostProfile, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeCostProfile(data: Boundaries["removeCostProfile"]["request"]): void;
}

function useRemoveCostProfile(
  costProfile: Identifiable<CostProfile>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveCostProfileRequestPending(costProfile),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveCostProfileRequestSuccess(costProfile),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveCostProfileRequestFailure(costProfile),
    ),
    removeCostProfile: core.removeCostProfile,
  };
}

export { useRemoveCostProfile };
